// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// Import your CSS
import './application.css'
import 'select2/dist/css/select2.css'

// Import your JavaScript
import '@hotwired/turbo-rails'
import '../controllers'
import "trix"
import "@rails/actiontext"
import $ from 'jquery'
import 'select2/dist/js/select2.js'

// Register controllers
import { Application } from "@hotwired/stimulus"
import ScoreAnimationController from "../controllers/score_animation_controller"
import TriangleAnimationController from "../controllers/triangle_animation_controller"

const application = Application.start()
application.register("score-animation", ScoreAnimationController)
application.register("triangle-animation", TriangleAnimationController)

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
